import ProfileRow from './ProfileRow';
import useProfileData from '../hooks/useProfileData';
import { Trash2 } from 'lucide-react';

/**
 * ProfileRowShare - Displays a profile row with share code as subtitle and delete button
 * 
 * Takes a share object and current user ID, internally determines the other user's ID.
 * Uses useProfileData hook to load profile data (handles loading/caching).
 * Sets the subtitle to the user's share code.
 * Includes a delete button on the right side.
 * 
 * @param {object} share - The share object with owner_id and shared_with_id
 * @param {string} meId - The current user's ID
 * @param {function} onDelete - Callback when delete button is clicked, receives object with message and shareId
 */
function ProfileRowShare({ share, meId, onDelete }) {
  // Determine the other user's ID from the share
  const otherUserId = share.owner_id === meId ? share.shared_with_id : share.owner_id;
  const { profile } = useProfileData(otherUserId);
  
  // Determine if user is owner or recipient
  const isOwner = share.owner_id === meId;

  const handleDelete = () => {
    if (onDelete) {
      const message = isOwner 
        ? `Are you sure you want to stop sharing your calendar with ${profile?.name || 'this user'}?`
        : `Are you sure you want to stop viewing ${profile?.name || 'their'}'s calendar?`;
      
      const confirmData = {
        message,
        shareId: share.id
      };
      onDelete(confirmData);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1">
        <ProfileRow 
          profile={profile} 
          size="md" 
          subtitle={`@${profile?.share_code || ''}`}
          boldSubtitle={true}
        />
      </div>
      <button
        onClick={handleDelete}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-destructive/10 hover:bg-destructive/20 transition-colors"
      >
        <Trash2 className="h-4 w-4 text-destructive" />
      </button>
    </div>
  );
}

export default ProfileRowShare;
